const form = document.querySelector('.userform');
const terminart = form.querySelector('#Terminart select');
const wochentag = form.querySelector('#Wochentag select');
const wunschtermine = form.querySelector('#Wunschtermine');
const tageszeit = form.querySelector('#Tageszeit select');

if (form && terminart && wochentag && tageszeit) {

    terminart.tage = {
        0: [2, 3, 4, 5, 6],
        1: [2, 3, 4, 5, 6],
        2: [2, 3, 4, 5, 6],
        3: [2, 3, 4, 5, 6],
        4: [5, 6]
    }
    terminart.zeiten = {
        0: [2, 3, 4],
        1: [2, 3, 4],
        2: [2, 3, 4],
        3: [2, 3, 4],
        4: [2, 4]
    }
    terminart.allOptions = terminart.options;

    wochentag.zeiten = {
        0: [2, 3, 4],
        1: [2, 3, 4],
        2: [2, 4],
        3: [2, 3],
        4: [2],
        5: [2, 4],
        6: [2]
    }
    wochentag.allOptions = wochentag.querySelectorAll('option');
    wochentag.allOptions.forEach((option, index) => {
        option.removeAttribute('selected');
        option.setAttribute('data-id', index);
    });

    tageszeit.tage = {
        0: [2, 3, 4, 5, 6],
        1: [2, 3, 4, 5, 6],
        2: [2, 3, 4, 5, 6],
        3: [3],
        4: [2, 5]
    }
    tageszeit.allOptions = tageszeit.querySelectorAll('option');
    tageszeit.allOptions.forEach((option, index) => {
        option.removeAttribute('selected');
        option.setAttribute('data-id', index);
    });

    terminart.addEventListener('change', event => {
        switch (event.currentTarget.value) {
            case "Kosmetische Behandlung":
                wochentag.show([0, 1, 5, 6]);
                tageszeit.show([0, 1, 2, 4]);
                break;
            default:
                wochentag.show([0, 1, 2, 3, 4, 5, 6]);
        }
    });


    wochentag.addEventListener('change', (event) => {
        const index = +wochentag.item(wochentag.selectedIndex).dataset.id;
        const selectedIndex = terminart.selectedIndex;
        const intersection = terminart.zeiten[selectedIndex];
        const result = wochentag.zeiten[index].filter(x => intersection.includes(x));
        if (result.length > 1) {
            result.unshift(0, 1);
        }
        tageszeit.show(result);
    });

    tageszeit.addEventListener('change', (event) => {
        const index = +tageszeit.item(tageszeit.selectedIndex).dataset.id;
        const selectedIndex = terminart.selectedIndex;
        const intersection = terminart.tage[selectedIndex];
        const result = tageszeit.tage[index].filter(x => intersection.includes(x));
        if (result.length > 1) {
            result.unshift(0, 1);
        }
        wochentag.show(result);

    });

    form.querySelectorAll('select').forEach(element => {

        element.show = (optionIds) => {
            element.removeAttribute('disabled');
            const activeId = +element.item(element.selectedIndex).dataset.id;

            for (const option in element.options) {
                element.remove(option.index);
            }

            let selectedIndex = 0, i = 0;
            element.allOptions.forEach(option => {
                const index = +option.dataset.id;
                if (optionIds.includes(index)) {
                    if (activeId === index) {
                        option.setAttribute('selected', 'selected');
                        selectedIndex = i;
                    }
                    element.add(option);
                    i++;
                }
            })

            if (element.options.length <= 1) {
                element.setAttribute('disabled', 'disabled');
            }
            element.selectedIndex = selectedIndex;

        }

        element.hideOption = (el) => {
            if (!el.classList.contains('hide')) {
                el.classList.add('hide');
                const wrapper = document.createElement('div');
                wrapper.classList.add('wrapper')
                wrapper.style.display = "none";
                el.replaceWith(wrapper);
                wrapper.appendChild(el);
            }
        }

        element.showOption = (el) => {
            if (el.classList.contains('hide')) {
                el.parentElement.replaceWith(el);
                el.classList.remove('hide');
            }
        }
    });

    form.addEventListener('submit', event => {
        wochentag.removeAttribute('disabled');
        tageszeit.removeAttribute('disabled');
    })
}

if (form && terminart && wunschtermine) {
    const searchParams = new URLSearchParams(window.location.search);
    const options = wunschtermine.querySelectorAll('input');

    options.forEach(option => option.parentNode.classList.add('show'));

    terminart.addEventListener('change', event => {
        switch (event.currentTarget.value) {
            case "Allgemeine Sprechstunde":
                for (let i = 0; i < options.length; i++) {
                    const option = options[i];
                    if (![0, 1, 2, 3, 4, 5, 6, 8].includes(i)) {
                        option.checked = false;
                        option.disabled = "disabled";
                        option.parentNode.classList.remove('show');
                        option.parentNode.classList.add('hide');
                    } else {
                        option.parentNode.classList.remove('hide');
                        option.disabled = "";
                        option.parentNode.style.display = "block";
                        option.parentNode.classList.add('show');
                    }
                }
                break;
            case "Kosmetische Behandlung":
                for (let i = 0; i < options.length; i++) {
                    const option = options[i];
                    if (![0, 6, 7, 8].includes(i)) {
                        option.checked = false;
                        option.disabled = "disabled";
                        option.parentNode.style.display = "none";
                        option.parentNode.classList.remove('show');
                    } else {
                        option.parentNode.classList.remove('hide');
                        option.disabled = "";
                        option.parentNode.style.display = "block";
                        option.parentNode.classList.add('show');
                    }
                }
                break;
            default:
                for (let i = 0; i < options.length; i++) {
                    const option = options[i];
                    option.parentNode.classList.remove('hide');
                    option.disabled = "";
                    option.parentNode.style.display = "block";
                    option.parentNode.classList.add('show');
                }
        }
    });

    options.forEach((option) => {
        option.addEventListener('change', event => {
            const count = wunschtermine.querySelectorAll(':checked').length;
            const max = wunschtermine.querySelectorAll('.middleColumn .show').length - 1;
            if (event.currentTarget.id === options.item(0).id) {
                options.forEach((option, index) => {
                    option.checked = index === 0;
                })
            } else if (count > 1 && options.item(0).checked) {
                options.item(0).checked = false;
            } else if (count === max || count === 0) {
                options.forEach((option, index) => {
                    option.checked = index === 0;
                })
            }
        })
    });

    form.querySelectorAll('select').forEach(element => {

        element.show = (optionIds) => {
            element.removeAttribute('disabled');
            const activeId = +element.item(element.selectedIndex).dataset.id;

            for (const option in element.options) {
                element.remove(option.index);
            }

            let selectedIndex = 0, i = 0;
            element.allOptions.forEach(option => {
                const index = +option.dataset.id;
                if (optionIds.includes(index)) {
                    if (activeId === index) {
                        option.setAttribute('selected', 'selected');
                        selectedIndex = i;
                    }
                    element.add(option);
                    i++;
                }
            })

            if (element.options.length <= 1) {
                element.setAttribute('disabled', 'disabled');
            }
            element.selectedIndex = selectedIndex;

        }

        element.hideOption = (el) => {
            if (!el.classList.contains('hide')) {
                el.classList.add('hide');
                const wrapper = document.createElement('div');
                wrapper.classList.add('wrapper')
                wrapper.style.display = "none";
                el.replaceWith(wrapper);
                wrapper.appendChild(el);
            }
        }

        element.showOption = (el) => {
            if (el.classList.contains('hide')) {
                el.parentElement.replaceWith(el);
                el.classList.remove('hide');
            }
        }
    });

}
